/**
 * Slugifies a string to be used as an id component of elements and pages in an event.
 *
 * @param input - String to slugify
 * @returns Slugified string
 */
const slugifyString = (input: string): string => {
  return input.replaceAll("/", " ").trim().replaceAll(" ", "-").toLowerCase();
};

export { slugifyString };
